import * as React from 'react';
import * as _ from 'lodash';

import './secondary-button.scss';

interface SecondaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  buttonId?: string;
}

const SecondaryButton = ({ text, buttonId, type = 'submit', onClick, ...htmlProps }: SecondaryButtonProps) => {
  const handleOnClick = e => _.isFunction(onClick) && onClick(e);

  return (
    <button {...htmlProps} id={buttonId} className="SecondaryButton" type={type} onClick={handleOnClick}>
      {text}
    </button>
  );
};

export default SecondaryButton;
